import en from './lang/en.js'
import ar from './lang/ar.js'
import store from '@/store'
let storeInstance = store
let allStrings = {
  en: en,
  ar
}
export const getLang = () => localStorage.getItem('ap_lang') || 'en'

export function t (key) {
  return allStrings[storeInstance.state.i18n.lang][key] || '[' + key + ']'
}
export default {
  methods: {
    t
  }
}
